import {
  ActionIcon,
  Box,
  Burger,
  Button,
  Collapse,
  Divider,
  Drawer,
  Flex,
  Group,
  Header,
  HoverCard,
  Image,
  Indicator,
  List,
  Menu,
  Modal,
  Overlay,
  ScrollArea,
  Text,
  TextInput,
  ThemeIcon,
  UnstyledButton,
  createStyles,
} from '@mantine/core';

import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import {
  IconArrowsLeftRight,
  IconBook,
  IconChartPie3,
  IconChevronRight,
  IconCode,
  IconCoin,
  IconFingerprint,
  IconHeart,
  IconLogout,
  IconMapPin,
  IconNotification,
  IconSearch,
  IconSettings,
  IconShoppingCart,
  IconUser,
  IconUserCircle,
  IconBell,
  IconCategory,
} from '@tabler/icons-react';
import { useContext, useEffect, useState } from 'react';
import CitySelectionModal from './CitySelectionModal';
import { useLocation, useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { api } from '../services/master.service';
import { IconArrowNarrowLeft, IconX } from '@tabler/icons';
import { CartContext } from '../App';
import { header_bg_shade, header_text_shade, is_mobile_view, logo_name } from '../config';

const useStyles = createStyles((theme) => ({
  link: {
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center',
    height: '100%',
    paddingLeft: theme.spacing.md,
    paddingRight: theme.spacing.md,
    textDecoration: 'none',
    color: theme.colors.brand[header_text_shade],
    fontWeight: 500,
    fontSize: theme.fontSizes.sm,

    [theme.fn.smallerThan('sm')]: {
      height: 42,
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },

    ...theme.fn.hover({
      backgroundColor:
        theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
    }),
  },

  subLink: {
    width: '100%',
    padding: `${theme.spacing.xs} ${theme.spacing.md}`,
    borderRadius: theme.radius.md,

    ...theme.fn.hover({
      backgroundColor:
        theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[0],
    }),

    '&:active': theme.activeStyles,
  },

  dropdownFooter: {
    backgroundColor:
      theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[0],
    margin: `calc(${theme.spacing.md} * -1)`,
    marginTop: theme.spacing.sm,
    padding: `${theme.spacing.md} calc(${theme.spacing.md} * 2)`,
    paddingBottom: theme.spacing.xl,
    borderTop: `${1} solid ${theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[1]
      }`,
  },

  hiddenMobile: {
    [theme.fn.smallerThan('sm')]: {
      display: 'none',
    },
  },

  hiddenDesktop: {
    [theme.fn.largerThan('sm')]: {
      display: 'none',
    },
  },
}));

const mockdata = [
  {
    icon: IconCode,
    title: 'Open source',
    description: 'This Pokémon’s cry is very loud and distracting',
  },
  {
    icon: IconCoin,
    title: 'Free for everyone',
    description: 'The fluid of Smeargle’s tail secretions changes',
  },
  {
    icon: IconBook,
    title: 'Documentation',
    description: 'Yanma is capable of seeing 360 degrees without',
  },
  {
    icon: IconFingerprint,
    title: 'Security',
    description: 'The shell’s rounded shape and the grooves on its.',
  },
  {
    icon: IconChartPie3,
    title: 'Analytics',
    description: 'This Pokémon uses its flying ability to quickly chase',
  },
  {
    icon: IconNotification,
    title: 'Notifications',
    description: 'Combusken battles with the intensely hot flames it spews',
  },
];

export default function AppHeader() {
  const [logo, setLogo] = useState('');
  useEffect(() => {
    import(`../static/images/${logo_name}`).then((module) => {
      setLogo(module.default);
    });
  }, [])
  const navigate = useNavigate();
  const location = useLocation();
  let isMobileScreen = useMediaQuery('(max-width: 768px)');
  isMobileScreen = is_mobile_view ? is_mobile_view : isMobileScreen;
  const { cartItemCount, setCartItemCount, search, setSearch } = useContext(CartContext);

  const [drawerOpened, { toggle: toggleDrawer, close: closeDrawer }] =
    useDisclosure(false);
  const [linksOpened, { toggle: toggleLinks }] = useDisclosure(false);
  const { classes, theme } = useStyles();

  const [citySelectionOpened, setCitySelectionOpened] = useState(false);
  const [categories, setCategories] = useState([]);
  const [notifyCount, setNotifyCount] = useState(0);
  //const [cartCount, setCartCount] = useState(null);

  const queryString = window.location.search;

  // Create a URLSearchParams object
  const params = new URLSearchParams(queryString);
  const searchParams = params.get("search");
  // const userFirstName = localStorage.getItem('user_first_name');
  const [headerFirstName, setHeaderFirstName] = useState(localStorage.getItem('user_first_name'));
 const [hoveredLeftCategory, setHoveredLeftCategory] = useState(null);
const [hoveredRightCategory, setHoveredRightCategory] = useState(null);

  const [notification, setNotification] = useState(null);

useEffect(() => {
  api.get_website_notification().then(res => {
    const msg = res.data?.notification?.trim(); // remove extra spaces

    if (res.success && msg && msg !== "NA" && msg !== "na") {
      setNotification(msg);
    } else {
      setNotification(null);
    }
  });
}, []);

 useEffect(() => {
    const intervalId = setInterval(() => {
        const currentFirstName = localStorage.getItem('user_first_name');
        if (currentFirstName !== headerFirstName) {
            setHeaderFirstName(currentFirstName);
        }
    }, 500); 
    return () => clearInterval(intervalId); 
}, [headerFirstName]);
 
  useEffect(() => {
    if (
    !localStorage.getItem('city_pincode') ||
    !localStorage.getItem('counter_id')
  ) {
      setCitySelectionOpened(true);
    }
  }, []);

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      navigate(`/products?search=${event.target.value}`);
      //setSearchOpened(false);
    }
  };

  useEffect(() => {
    if (searchParams) {
      setSearch(searchParams)
    } else {
      setSearch('')
    }
  }, [searchParams])

  useEffect(() => {
    api.get_categories().then((res) => {
      console.log(res.data.data);
      setCategories(res.data.data);
    });
  }, []);

  useEffect(() => {
    api.get_cart().then((res) => {
      console.log(res.data.data);
      //setCartCount(res.data.data?.cartitem.length);
      setCartItemCount(res.data.data?.cartitem.length);
    });
  }, []);
const [totalProducts, setTotalProducts] = useState(0);
useEffect(() => {
api.get_products(1, 10000, "", "", "", "").then((res) => {
    console.log("Products API response:", res.data); 
    if (res.data.success) {
setTotalProducts(res.data.data?.length ?? 0);
}
  });
}, []);

  useEffect(() => {
  api.get_notify_list().then((res) => {
    if (res && res.success !== false) {
      // Filter only "Available" notifications
      const available = res.data?.filter(n => n.status === "Available") || [];
      setNotifyCount(available.length);
    }
  });
}, []);

  const links = mockdata.map((item) => (
    <UnstyledButton className={classes.subLink} key={item.title}>
      <Group noWrap align="flex-start">
        <ThemeIcon size={34} variant="default" radius="md">
          <item.icon size={22} color={theme.fn.primaryColor()} />
        </ThemeIcon>
        <div>
          <Text size="sm" fw={500}>
            {item.title}
          </Text>
          <Text size="xs" color="dimmed">
            {item.description}
          </Text>
        </div>
      </Group>
    </UnstyledButton>
  ));

  if (
    (!localStorage.getItem('city_name') ||
      !localStorage.getItem('city_id') ||
      !localStorage.getItem('counter_id')||
      !localStorage.getItem('city_pincode')) &&
    !citySelectionOpened
  ) {
    setCitySelectionOpened(true);
  }

  return (
    <>
    {notification ? (
  <div
    style={{
      background: "rgb(255 230 6)",
      textAlign: "center",
      color: "red",
      // fontWeight:"bold",
      position: "fixed",
      top: 0,
      width: "100%",
      zIndex: 2000,
      overflow: "hidden",     // important for scroll
      whiteSpace: "nowrap",    // keep text in one line
    }}
  >
    <div
      style={{
        display: "inline-block",
        paddingLeft: "100%",
        animation: "marquee 20s linear infinite",
      }}
    >
      {notification}
    </div>

    <style>
      {`
        @keyframes marquee {
          0%   { transform: translateX(0%); }
          100% { transform: translateX(-100%); }
        }
      `}
    </style>
  {/* </div>
) : null} */}
    <span>{notification}</span>

    {/* Close Button */}
    <span
      style={{
        position: "absolute",
        right: 10,
        top: 2,
        cursor: "pointer",
        color: "#000",
        fontSize: "12px",
        fontWeight: 700,
      }}
      onClick={() => setNotification(null)}
    >
      ✕
    </span>
  </div>
) : null}


   <Box
  pb={2}
  style={{
    position: 'fixed',
    top: notification ? '5px' : '0px', // 🔥 Key Logic Here
    width: '100%',
    zIndex: 10,
    background: '#fff',
  }}
>

        <Header>
          <Group
            justify="space-between"
            pt={'lg'}
            px="md"
            position="apart"
            sx={{ height: '100%' }}
          >
            {/* <MantineLogo size={30} /> */}
            <Flex align={'center'} justify={'space-between'} mr={'3%'}>
              {location.pathname !== '/' && isMobileScreen ? (
                <IconArrowNarrowLeft
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    // 👇 If login page, go to root page
                    if (location.pathname === '/login') {
                      navigate('/');
                    } else {
                      navigate(-1);
                    }
                  }}
                />
              ) : (
                <></>
              )}
              <Box h={'100%'}>
                <Text
                  fw={800}
                  size={'lg'}
                  style={{
                    letterSpacing: '-1px',
                  }}
                >
                  <Link
                    style={{
                      textDecoration: 'none',
                      color: 'inherit',
                    }}
                    to={'/'}
                  >
                    <img
                      src={logo}
                      width={150}
                      height={49}
                      style={{
                        objectFit: 'cover',
                      }}
                      alt="logo"
                    />
                  </Link>
                </Text>
              </Box>
            </Flex>
            <Group
              justify={'center'}
              w={'30%'}
              h={'100%'}
              sx={{ height: '100%', display: isMobileScreen ? 'none' : 'block' }}
              spacing={0}
            >
              <Box w={'100%'}>
                <TextInput
                  bg={'white'}
                  variant="unstyled"
                 placeholder={
    totalProducts > 0
      ? `Search among ${totalProducts} products...`
      : "Search products..."
  }

                  radius={'500px'}
                  icon={<IconSearch style={{ marginLeft: 10 }} width={18} />}
                  rightSection={
                    search !== '' ? (
                      <IconX
                        onClick={() => {
                          if (location.pathname === '/products') {
                            navigate(`/products?search=`);
                          }
                          setSearch('');
                        }}
                      />
                    ) : (
                      <></>
                    )
                  }
                  size="sm"
                  style={{
                    border: '2px solid ' + theme.colors.brand[8],
                    borderRadius: '500px',
                  }}
                  value={search}
                  onChange={(event) => setSearch(event.currentTarget.value)}
                  onKeyDown={(val) => {
                    handleKeyPress(val);
                  }}
                />
              </Box>
            </Group>
            <Group
              h={'100%'}
              position="right"
              sx={isMobileScreen ? { display: 'none' } : {}}
            >
              {localStorage.getItem('user_token') ? (
                <>
                {headerFirstName && (
                    <Text 
                      size="sm" 
                      fw={500} 
                      pr={5} 
                      tt={'capitalize'}
                    >
                      Hi, {headerFirstName}
                    </Text>
                  )}
                  <Menu shadow="md">
                    <Menu.Target>
                      <ActionIcon>
                        <IconUserCircle />
                      </ActionIcon>
                    </Menu.Target>
                    <Menu.Dropdown>
                      <Menu.Item
                        onClick={() => {
                          navigate('/account');
                        }}
                        icon={<IconUser size={14} />}
                      >
                        My Account
                      </Menu.Item>
                      <Menu.Item
                        onClick={() => {
                          let city_name = localStorage.getItem('city_name');
                          let city_pincode = localStorage.getItem('city_pincode');
                          let city_id = localStorage.getItem('city_id');
                          localStorage.clear();
                          localStorage.setItem('city_name', city_name);
                          localStorage.setItem('city_pincode', city_pincode);
                          localStorage.setItem('city_id', city_id);
                          navigate('/');
                        }}
                        icon={<IconLogout size={14} />}
                        color="red"
                      >
                        Logout
                      </Menu.Item>
                    </Menu.Dropdown>
                  </Menu>
                  <ActionIcon
                     onClick={() => {
                       navigate('/notify');
                     }}
                   >
                     <Indicator
                       inline
                       label={notifyCount > 0 ? notifyCount.toString() : null}
                       size={16}
                       color="red"
                       disabled={notifyCount === 0}
                     >
                       <IconBell />
                     </Indicator>
                   </ActionIcon>

                  <ActionIcon
                    onClick={() => {
                      navigate('/cart');
                    }}
                  >
                    <Indicator
                      inline
                      label={cartItemCount?.toString()}
                      size={16}
                      disabled={cartItemCount === 0}
                    >
                      <IconShoppingCart />
                    </Indicator>
                  </ActionIcon>
                </>
              ) : (
                <ActionIcon
                  onClick={() => {
                    navigate('/login');
                  }}
                >
                  <IconUserCircle />
                </ActionIcon>
              )}
              <Button
               variant="subtle"
               leftIcon={<IconMapPin />}
               size="xs"
               onClick={() => {
                 setCitySelectionOpened(true);
               }}
               maw={'200px'}
             >
               <Flex direction="column" align="flex-start">
                 <Text truncate="end">
                   {localStorage.getItem('city_name')
                     ? localStorage.getItem('city_name')
                     : 'Select Location'}
                 </Text>
                 {localStorage.getItem('counter_name') && (
                   <Text size="10px" color="dimmed" truncate="end">
                     {localStorage.getItem('counter_name')}
                   </Text>
                 )}
               </Flex>
             </Button>

              {/* <Button variant="default">Log in</Button>
            <Button>Sign up</Button> */}
          </Group>
          

            {/* <Burger
              h={'100%'}
              opened={drawerOpened}
              onClick={toggleDrawer}
              className={classes.hiddenDesktop}
            /> */}
            {isMobileScreen ? (
             <Group>
               {localStorage.getItem('user_token') ? (
                 <>
                   <ActionIcon
                     onClick={() => {
                       navigate('/notify');
                     }}
                   >
                     <Indicator
                       inline
                       label={notifyCount > 0 ? notifyCount.toString() : null}
                       size={16}
                       color="red"
                       disabled={notifyCount === 0}
                     >
                       <IconBell />
                     </Indicator>
                   </ActionIcon>
             
                   <ActionIcon
                     onClick={() => {
                       navigate('/cart');
                     }}
                   >
                     <Indicator
                       inline
                       label={cartItemCount?.toString()}
                       size={16}
                       disabled={cartItemCount === 0}
                     >
                       <IconShoppingCart />
                     </Indicator>
                   </ActionIcon>
             
                   <ActionIcon
                     onClick={() => {
                       setCitySelectionOpened(true);
                     }}
                   >
                     <IconMapPin
                       color={localStorage.getItem('city_name') ? 'green' : '#adb5bd'}
                     />
                   </ActionIcon>
                 </>
               ) : (
                 <></>
               )}
             </Group>

            ) : (
              <></>
            )}
          </Group>
           {isMobileScreen && localStorage.getItem('user_token') && headerFirstName ? (
              <Box 
                style={{
                  position: 'absolute', 
                  top: 63, 
                  right: 20, 
                  zIndex: 11, 
                }}
              > 
                <Text size="12px" fw={700} color="#23582b" tt={'capitalize'}>
                  Hi, {headerFirstName}
                </Text>
              </Box>
            ) : (
              <></>
            )}
          
          <Flex
            align={'center'}
            justify={'center'}
            mt={20}
            p={isMobileScreen ? 5 : 0}
            pt={isMobileScreen ? 5 : 20}
            style={{
              borderTop: '1px solid #eee',
              boxShadow: '0px 6px 10px ' + theme.colors.brand[0],
            }}
            bg={theme.colors.brand[header_bg_shade]}
          >
            {isMobileScreen ? (
              <Box w={'90%'}>
                <TextInput
                  bg={'white'}
                  variant="unstyled"
                  placeholder={
                    totalProducts > 0
                      ? `Search among ${totalProducts} products...`
                      : "Search products..."
                  }
                  radius={'500px'}
                  icon={<IconSearch style={{ marginLeft: 10 }} width={18} />}
                  rightSection={
                    search !== '' ? (
                      <IconX
                        onClick={() => {
                          if (location.pathname === '/products') {
                            navigate(`/products?search=`);
                          }
                          setSearch('');
                        }}
                      />
                    ) : (
                      <></>
                    )
                  }
                  size="xs"
                  style={{
                    border: '2px solid ' + theme.colors.brand[8],
                    borderRadius: '500px',
                  }}
                  value={search}
                  onChange={(event) => setSearch(event.currentTarget.value)}
                  onKeyDown={(val) => {
                    handleKeyPress(val);
                  }}
                />
              </Box>
            ) : (
              <></>
            )}
            
            <Group
              sx={
                isMobileScreen ? { height: '100%', display: 'none' } : { height: '100%' }
              }
              justify="center"
              spacing={0}
              mb={'lg'}
            >
              <span
                onClick={() => {
                  navigate('/');
                }}
                className={classes.link}
              >
                Home
              </span>

              <span
                onClick={() => {
                  navigate('/products');
                }}
                className={classes.link}
              >
                Our Products
              </span>

              {location.pathname !== '/' ? (
                <>
                  <span
                    className={classes.link}
                    onClick={() => {
                      navigate('/categories');
                    }}
                  >
                    Categories
                  </span>
                </>
              ) : (
 <span className={classes.link}>
  <HoverCard
    shadow="md"
    openDelay={200}
    closeDelay={300}
    position="bottom-start"
  >
    <HoverCard.Target>
  <span 
    onClick={() => navigate('/categories')}
    style={{ cursor: 'pointer' }}
  >
    Explore Categories
  </span>
</HoverCard.Target>
    <HoverCard.Dropdown
  style={{
    width: "900px",
    padding: 0,
    backgroundColor: "#fff",
    boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
    borderRadius: "8px",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
  }}
>
  {/* LEFT CATEGORY COLUMN */}
  <div
    style={{
      padding: "16px",
      borderRight: "1px solid #eee",
      background: "#fff",
    }}
  >
    {categories.slice(0, Math.ceil(categories.length / 2)).map((cat) => (
      <div
        key={cat.id}
        onMouseEnter={() => {
          setHoveredLeftCategory(cat);
          setHoveredRightCategory(null);
        }}
        onClick={() => navigate(`/category/?id=${cat.id}`)}
        style={{
          cursor: "pointer",
          fontSize: "15px",
          fontWeight: "bold",
          padding: "6px 10px",
          borderRadius: "4px",
          marginBottom: "4px",
          background:
            hoveredLeftCategory?.id === cat.id ? "#e9f6f0" : "transparent",
          color: hoveredLeftCategory?.id === cat.id ? "theme.colors.brand[9]" : "#333",
          transition: "background 0.2s",
        }}
      >
        {cat.title}
      </div>
    ))}

   {/* LEFT SIDE SUBCATEGORIES */}
{hoveredLeftCategory && (
  <div
    style={{
      position: "absolute",
      top: 0,
      right: "100%",
      width: "420px", // ⬅️ wider
      height: "100%",
      background: "#f6fcf8ff",
      border: "1px solid #e0e0e0",
      borderRadius: "8px 0 0 8px",
      padding: "16px",
      boxShadow: "-4px 4px 12px rgba(0,0,0,0.05)",
      display: "flex",
      flexDirection: "column",
      zIndex: 5,
      overflow: "hidden",
    }}
  >
    <div
      style={{
        fontWeight: "bold",
        marginBottom: "10px",
        color: "#0b8457",
      }}
    >
      {hoveredLeftCategory.title}
    </div>

    <div
      style={{
        display: "grid",
        gridTemplateColumns:
          hoveredLeftCategory.sub_category?.length > 20
            ? "repeat(4, 1fr)"
            : hoveredLeftCategory.sub_category?.length > 12
            ? "repeat(3, 1fr)"
            : hoveredLeftCategory.sub_category?.length > 6
            ? "repeat(2, 1fr)"
            : "repeat(1, 1fr)",
        gap: '8px 16px',
          alignItems: 'start',
        // overflowY: "auto",
      }}
    >
      {hoveredLeftCategory.sub_category?.map((sub) => (
        <div
          key={sub.id}
          onClick={() =>
            navigate(
              `/category/?id=${hoveredLeftCategory.id}&subcategory=${sub.id}`
            )
          }
          style={{
            cursor: "pointer",
            fontSize: "14px",
            padding: "5px 8px",
            borderRadius: "4px",
            transition: "background 0.2s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.background = "#e9f6f0")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.background = "transparent")
          }
        >
          {sub.title}
        </div>
      ))}
    </div>
               {hoveredLeftCategory.sub_category?.length > 0 && (
          <div
            onClick={() => navigate(`/category/?id=${hoveredLeftCategory.id}`)}
            style={{
              marginTop: "12px",
              fontWeight: "600",
              color: "#0b8457",
              cursor: "pointer",
            }}
          >
            View all in {hoveredLeftCategory.title} →
          </div>
        )}
      </div>
    )}
  </div>

  {/* RIGHT CATEGORY COLUMN */}
  <div
    style={{
      padding: "16px",
      borderLeft: "1px solid #eee",
      background: "#fff",
    }}
  >
    {categories.slice(Math.ceil(categories.length / 2)).map((cat) => (
      <div
        key={cat.id}
        onMouseEnter={() => {
          setHoveredRightCategory(cat);
          setHoveredLeftCategory(null);
        }}
        onClick={() => navigate(`/category/?id=${cat.id}`)}
        style={{
          cursor: "pointer",
          fontSize: "15px",
          fontWeight: "bold",
          padding: "6px 10px",
          borderRadius: "4px",
          marginBottom: "4px",
          background:
            hoveredRightCategory?.id === cat.id ? "#e9f6f0" : "transparent",
          color: hoveredRightCategory?.id === cat.id ? "theme.colors.brand[9]" : "#333",
          transition: "background 0.2s",
        }}
      >
        {cat.title}
      </div>
    ))}

    {/* RIGHT SIDE SUBCATEGORIES */}
{hoveredRightCategory && (
  <div
    style={{
      position: "absolute",
      top: 0,
      left: "100%",
      width: "420px", // ⬅️ wider
      height: "100%",
      background: "#f6fcf8ff",
      border: "1px solid #e0e0e0",
      borderRadius: "0 8px 8px 0",
      padding: "16px",
      boxShadow: "4px 4px 12px rgba(0,0,0,0.05)",
      display: "flex",
      flexDirection: "column",
      zIndex: 5,
      overflow: "hidden",
    }}
  >
    <div
      style={{
        fontWeight: "bold",
        marginBottom: "10px",
        color: "#0b8457",
      }}
    >
      {hoveredRightCategory.title}
    </div>

    <div
      style={{
        display: "grid",
        gridTemplateColumns:
          hoveredRightCategory.sub_category?.length > 20
            ? "repeat(4, 1fr)"
            : hoveredRightCategory.sub_category?.length > 12
            ? "repeat(3, 1fr)"
            : hoveredRightCategory.sub_category?.length > 6
            ? "repeat(2, 1fr)"
            : "repeat(1, 1fr)",
        gap: '8px 16px',
          alignItems: 'start',
        // overflowY: "auto",
      }}
    >
      {hoveredRightCategory.sub_category?.map((sub) => (
        <div
          key={sub.id}
          onClick={() =>
            navigate(
              `/category/?id=${hoveredRightCategory.id}&subcategory=${sub.id}`
            )
          }
          style={{
            cursor: "pointer",
            fontSize: "14px",
            padding: "5px 8px",
            borderRadius: "4px",
            transition: "background 0.2s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.background = "#e9f6f0")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.background = "transparent")
          }
        >
          {sub.title}
        </div>
      ))}
    </div>
               {hoveredRightCategory.sub_category?.length > 0 && (
          <div
            onClick={() => navigate(`/category/?id=${hoveredRightCategory.id}`)}
            style={{
              marginTop: "12px",
              fontWeight: "600",
              color: "#0b8457",
              cursor: "pointer",
            }}
          >
            View all in {hoveredRightCategory.title} →
          </div>
        )}
      </div>
    )}
  </div>
</HoverCard.Dropdown>



                  </HoverCard>
                </span>
              )}
              {localStorage.getItem('user_token') ? (
                <span
                  className={classes.link}
                  onClick={() => {
                    navigate('/account');
                  }}
                >
                  My Orders
                </span>
              ) : (
                <></>
              )}
            </Group>
          </Flex>
        </Header>

        <CitySelectionModal
          opened={citySelectionOpened}
          onClose={() => {
            //setCitySelectionOpened(false);
          }}
        />

        {/* <Modal
          opened={searchOpened}
          onClose={() => {
            setSearch('');
            setSearchOpened(false);
          }}
          title="Search Products"
        >
          <Box w={'100%'} mb={15} mt={10}>
            <TextInput
              variant="unstyled"
              placeholder="Search Among 1000 of products..."
              radius={'500px'}
              icon={<IconSearch style={{ marginLeft: 10 }} width={18} />}
              size="sm"
              style={{
                border: '2px solid ' + theme.colors.brand[8],
                borderRadius: '500px',
              }}
              value={search}
              onChange={(event) => setSearch(event.currentTarget.value)}
              onKeyDown={(val) => {
                handleKeyPress(val);
              }}
            />
          </Box>
        </Modal> */}

        {/* <Drawer
          opened={drawerOpened}
          onClose={closeDrawer}
          size="100%"
          padding="md"
          title="Navigation"
          className={classes.hiddenDesktop}
          zIndex={1000000}
        >
          <ScrollArea h={`calc(100vh - ${60})`} mx="-md">
            <Divider my="sm" color={theme.colorScheme === 'dark' ? 'dark.5' : 'gray.1'} />

            <a href="/" className={classes.link}>
              Home
            </a>
            <Collapse in={linksOpened}>{links}</Collapse>
            <a href="/categories" className={classes.link}>
              Explore Categories
            </a>
            <a href="/products" className={classes.link}>
              Our Products
            </a>
            {localStorage.getItem('user_token') ? (
              <a href="/account" className={classes.link}>
                My Orders
              </a>
            ) : (
              <></>
            )}

            <Divider my="sm" color={theme.colorScheme === 'dark' ? 'dark.5' : 'gray.1'} />

            <Group position="center" grow pb="xl" px="md">
              <Button variant="default">Log in</Button>
              <Button>Sign up</Button>
            </Group>
          </ScrollArea>
        </Drawer> */}
      </Box>
    </>
  );
}
